import { requireConfig } from '@onering/npm-package/web';
import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: requireConfig('KEYCLOAK_URL'),
  realm: requireConfig('KEYCLOAK_REALM'),
  clientId: requireConfig('KEYCLOAK_CLIENT_ID'),
});

export interface UserProfile {
  id: string;
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  fullName: string;
  department?: string;
  jobTitle?: string;
  employeeId?: string;
  phoneNumber?: string;
  groups?: string[];
}

export function getUserProfile(): UserProfile {
  const tokenParsed = keycloak.tokenParsed as
    | Record<string, unknown>
    | undefined;
  const str = (key: string): string | undefined => {
    const value = tokenParsed?.[key];
    return typeof value === 'string' ? value : undefined;
  };
  return {
    id: str('sub') ?? '',
    username: str('preferred_username') ?? '',
    firstName: str('given_name') ?? 'OneRing',
    lastName: str('family_name') ?? 'User',
    email: str('email') ?? '',
    fullName: tokenParsed
      ? `${str('given_name') ?? ''} ${str('family_name') ?? ''}`.trim()
      : 'OneRing User',
    department: str('department'),
    jobTitle: str('job_title'),
    employeeId: str('employee_id'),
    phoneNumber: str('phone_number'),
    groups: Array.isArray(tokenParsed?.groups)
      ? (tokenParsed.groups as string[])
      : undefined,
  };
}

export function getAccessToken(): string | undefined {
  return keycloak.token;
}

export const forceRefreshToken = (): Promise<boolean> =>
  keycloak.updateToken(-1);

export async function initKeycloak(): Promise<boolean> {
  try {
    const authenticated = await keycloak.init({
      checkLoginIframe: false,
      pkceMethod: 'S256',
    });

    if (!authenticated) {
      void keycloak.login({ idpHint: 'azure-ad' });
      return false;
    }

    setInterval(() => {
      keycloak.updateToken(60).catch(() => {
        void keycloak.login({ idpHint: 'azure-ad' });
      });
    }, 30_000);

    return true;
  } catch (error) {
    console.error('Keycloak init failed:', error);
    return false;
  }
}

export function logout(): void {
  keycloak.logout({ redirectUri: window.location.origin });
}

export default keycloak;
